<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar color="primary" dark>部屋選択</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <ryou-table
                  ref="ryouTablePop"
                  :rowKey="rowKey"
                  :title="'部屋選択一覧'"
                  :headers="headers"
                  :url="popUrl"
                  :showSelect="true"
                  :singleSelect="true"
                  :businessKeys="businessKey"
                  :autoLoad="false"
                  :dummy="false"
                  class="InsertTitle1"
                  :needSearch="true" 
                >
                </ryou-table>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          >
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'設定'"
            :handlerClick="handleOk"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  mixins: [RyouTableMixins],
  components: {
    RyouBlackBtn,
    RyouTable,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
  },
  props: {
    buildingId: {
      type: String,
      required: false,
      default: null,
    },
    setRoomIdFunc: {
      type: Function,
      required:true
    }
  },
  data: () => ({
    dialog: false,
    title: "",
    valid: true,
    inputRules: [],
    rowKey: "rowIndex",
    businessKey: ["building_id","room_id"],
    popUrl: {
      originlist: "/masterRoom/roomGet/",
    },
    tableName: "ryouTablePop",
    headers: [
      {
        text: "部屋番号",
        class: "blue lighten-2 title",
        value: "room_id",
        width: "135px",
        sortable: true,
        groupable: false,
      },
      {
        text: "使用状況",
        class: "blue lighten-2 title",
        value: "use_status_name",
        width: "135px",
        sortable: true,
        groupable: false,
      },
      {
        text: "階",
        class: "blue lighten-2 title",
        value: "floor",
        width: "100px",
        sortable: true,
        groupable: false,
      },
      {
        text: "性別",
        class: "blue lighten-2 title",
        value: "sex_name",
        width: "100px",
        sortable: true,
        groupable: false,
      },
    ],
  }),

  methods: {
    selectRooms() {
      this.open();
      this.title = "ユーザ選択";
    },
    handleCancel() {
      this.close();
    },
    handleOk() {
      this.setRoomIdFunc(this.selectionRows[0])
      this.close()
    },
    close() {
      this.$refs.ryouTablePop.selected = [];
      this.dialog = false;
    },
    open() {
      this.dialog = true;

      var that = this;
      setTimeout(() => {

        that.$refs.ryouTablePop.$on(
          "getSelectedRowKeys",
          this.getSelectedRowKeys
        );

        var tmp
        if (that.buildingId == null || that.buildingId == "") {
          tmp = "-1"
        } else {
          tmp = String(that.buildingId)
        }
        that.$refs.ryouTablePop.url.list =
        that.popUrl.originlist +
        tmp +
          "/" +
          "9999" //9999を指定して全部屋クラスを取得する
        
        // ポップアップ画面でグリッド検索処理を行う
        that.$refs.ryouTablePop.loadData();
      }, 10);

      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 12px !important;
}
.InsertTitle1 {
  padding: 5px 0px 0px 0px;
}
</style>